// DrainMaster Superior SWR Selfit and Ring Fit Drainage System Catalog
// HSN CODE: 39172390

export const drainmasterCatalog = {
    page: 1,
    title: "ASTRAL DRAINMASTER - SUPERIOR SWR SELFIT AND RING FIT DRAINAGE SYSTEM",
    hsn_code: "39172390",
    description: "Superior SWR Selfit and Ring Fit drainage pipes - IS:13592 and IS:14735 certified",
    certifications: ["IS:13592", "IS:14735"],
    features: [
        "ISI Certified - IS:13592 and IS:14735",
        "Selfit and Ring Fit systems",
        "Superior SWR drainage",
        "High quality standards"
    ],
    sections: [
        {
            name: "PIPES TYPE - A (SELFIT)",
            type: "A",
            fitting_type: "SELFIT",
            items: [
                { size_mm: "75", length_socket: "3M S/S", product_code: "M41110307", std_pkg: 1, price_inr_per_pc: 570.00 },
                { size_mm: "75", length_socket: "6 M S/S", product_code: "M41110607", std_pkg: 1, price_inr_per_pc: 1140.00 },
                { size_mm: "75", length_socket: "3 M D/S", product_code: "M41110307", std_pkg: 1, price_inr_per_pc: 603.00 },
                { size_mm: "75", length_socket: "6 M D/S", product_code: "M41110607", std_pkg: 1, price_inr_per_pc: 1205.00 },
                { size_mm: "75", length_socket: "2 FT D/S", product_code: "M42110207", std_pkg: 1, price_inr_per_pc: 165.00 },
                { size_mm: "75", length_socket: "3 FT D/S", product_code: "M42110307", std_pkg: 1, price_inr_per_pc: 234.00 },
                { size_mm: "75", length_socket: "4 FT D/S", product_code: "M42110407", std_pkg: 1, price_inr_per_pc: 285.00 },
                { size_mm: "75", length_socket: "5 FT S/S", product_code: "M42110507", std_pkg: 1, price_inr_per_pc: 405.00 },
                { size_mm: "75", length_socket: "6 FT D/S", product_code: "M42111607", std_pkg: 1, price_inr_per_pc: 509.0 },
                { size_mm: "75", length_socket: "3 FT S/S", product_code: "M41113307", std_pkg: 1, price_inr_per_pc: 219.00 },
                { size_mm: "75", length_socket: "4 FT S/S", product_code: "M41114407", std_pkg: 1, price_inr_per_pc: 273.00 },
                { size_mm: "75", length_socket: "6 FT S/S", product_code: "M41114607", std_pkg: 1, price_inr_per_pc: 384.00 },
                { size_mm: "90", length_socket: "3M S/S", product_code: "M41110308", std_pkg: 1, price_inr_per_pc: 813.00 },
                { size_mm: "90", length_socket: "3M S/S", product_code: "M41110608", std_pkg: 1, price_inr_per_pc: 1624.00 },
                { size_mm: "90", length_socket: "3 M D/S", product_code: "M42110308", std_pkg: 1, price_inr_per_pc: 837.00 },
                { size_mm: "90", length_socket: "6 M D/S", product_code: "M42110608", std_pkg: 1, price_inr_per_pc: 1648.00 },
                { size_mm: "90", length_socket: "2 FT D/S", product_code: "M42110208", std_pkg: 1, price_inr_per_pc: 234.00 },
                { size_mm: "90", length_socket: "3 FT D/S", product_code: "M41113308", std_pkg: 1, price_inr_per_pc: 292.00 },
                { size_mm: "90", length_socket: "4 FT D/S", product_code: "M42110408", std_pkg: 1, price_inr_per_pc: 428.00 },
                { size_mm: "90", length_socket: "5 FT D/S", product_code: "M42110608", std_pkg: 1, price_inr_per_pc: 590.00 },
                { size_mm: "90", length_socket: "2 FT S/S", product_code: "M41112208", std_pkg: 1, price_inr_per_pc: 191.00 },
                { size_mm: "90", length_socket: "3 FT S/S", product_code: "M41113308", std_pkg: 1, price_inr_per_pc: 267.00 },
                { size_mm: "90", length_socket: "4 FT S/S", product_code: "M41114408", std_pkg: 1, price_inr_per_pc: 404.00 },
                { size_mm: "90", length_socket: "6 FT S/S", product_code: "M41116608", std_pkg: 1, price_inr_per_pc: 543.00 },
                { size_mm: "110", length_socket: "3M S/S", product_code: "M41110309", std_pkg: 1, price_inr_per_pc: 1047.00 },
                { size_mm: "110", length_socket: "3M S/S", product_code: "M41110609", std_pkg: 1, price_inr_per_pc: 2092.00 },
                { size_mm: "110", length_socket: "3 M D/S", product_code: "M42110309", std_pkg: 1, price_inr_per_pc: 1058.00 },
                { size_mm: "110", length_socket: "6 M D/S", product_code: "M42110609", std_pkg: 1, price_inr_per_pc: 2171.00 },
                { size_mm: "110", length_socket: "2 FT D/S", product_code: "M42110209", std_pkg: 1, price_inr_per_pc: 279.00 },
                { size_mm: "110", length_socket: "3 FT D/S", product_code: "M42113309", std_pkg: 1, price_inr_per_pc: 377.00 },
                { size_mm: "110", length_socket: "4 FT D/S", product_code: "M42114409", std_pkg: 1, price_inr_per_pc: 482.00 },
                { size_mm: "110", length_socket: "6 FT D/S", product_code: "M42116609", std_pkg: 1, price_inr_per_pc: 692.00 },
                { size_mm: "110", length_socket: "2 FT S/S", product_code: "M41112209", std_pkg: 1, price_inr_per_pc: 255.00 },
                { size_mm: "110", length_socket: "3 FT S/S", product_code: "M41112209", std_pkg: 1, price_inr_per_pc: 255.00 },
                { size_mm: "110", length_socket: "4 FT S/S", product_code: "M41114409", std_pkg: 1, price_inr_per_pc: 469.00 },
                { size_mm: "110", length_socket: "6 FT S/S", product_code: "M41116609", std_pkg: 1, price_inr_per_pc: 679.00 },
                { size_mm: "110", length_socket: "12 FT S/S", product_code: "M41110609", std_pkg: 1, price_inr_per_pc: 1240.00 }
            ]
        },
        {
            name: "PIPES TYPE - A (CONTINUED)",
            type: "A",
            fitting_type: "SELFIT",
            items: [
                { size_mm: "160", length_socket: "3M S/S", product_code: "M41110312", std_pkg: 1, price_inr_per_pc: 2328.00 },
                { size_mm: "160", length_socket: "6 M S/S", product_code: "M41110612", std_pkg: 1, price_inr_per_pc: 4638.00 },
                { size_mm: "160", length_socket: "3 M D/S", product_code: "M42110312", std_pkg: 1, price_inr_per_pc: 2368.00 },
                { size_mm: "160", length_socket: "6 M D/S", product_code: "M42110612", std_pkg: 1, price_inr_per_pc: 4668.00 },
                { size_mm: "160", length_socket: "3 FT D/S", product_code: "M42113312", std_pkg: 1, price_inr_per_pc: 636.00 },
                { size_mm: "160", length_socket: "4 FT D/S", product_code: "M42114412", std_pkg: 1, price_inr_per_pc: 698.00 },
                { size_mm: "160", length_socket: "6 FT D/S", product_code: "M42116612", std_pkg: 1, price_inr_per_pc: 733.00 },
                { size_mm: "160", length_socket: "3 FT S/S", product_code: "M421123312", std_pkg: 1, price_inr_per_pc: 1088.00 },
                { size_mm: "160", length_socket: "4 FT S/S", product_code: "M42112412", std_pkg: 1, price_inr_per_pc: 1358.00 },
                { size_mm: "160", length_socket: "6 FT S/S", product_code: "M42110612", std_pkg: 1, price_inr_per_pc: 1970.00 },
                { size_mm: "160", length_socket: "2FT S/S", product_code: "M41110212", std_pkg: 1, price_inr_per_pc: 664.00 },
                { size_mm: "160", length_socket: "3 FT S/S", product_code: "M41112312", std_pkg: 1, price_inr_per_pc: 1004.00 },
                { size_mm: "160", length_socket: "6 FT D/S", product_code: "M42112612", std_pkg: 1, price_inr_per_pc: 1004.00 }
            ]
        },
        {
            name: "PIPES TYPE - B (RING FIT)",
            type: "B",
            fitting_type: "RING FIT",
            items: [
                { size_mm: "90", length_socket: "3FT S/S", product_code: "M41123308", std_pkg: 1, price_inr_per_pc: 396.00 },
                { size_mm: "90", length_socket: "4 FT S/S", product_code: "M41124408", std_pkg: 1, price_inr_per_pc: 509.00 },
                { size_mm: "90", length_socket: "6 FT S/S", product_code: "M41126608", std_pkg: 1, price_inr_per_pc: 778.00 },
                { size_mm: "110", length_socket: "3M S/S", product_code: "M41120309", std_pkg: 1, price_inr_per_pc: 1560.00 },
                { size_mm: "110", length_socket: "6 M S/S", product_code: "M41120609", std_pkg: 1, price_inr_per_pc: 2987.00 },
                { size_mm: "110", length_socket: "3 FT D/S", product_code: "M42120309", std_pkg: 1, price_inr_per_pc: 1504.00 },
                { size_mm: "110", length_socket: "6 M D/S", product_code: "M42120609", std_pkg: 1, price_inr_per_pc: 3048.00 },
                { size_mm: "110", length_socket: "2 FT S/S", product_code: "M41122209", std_pkg: 1, price_inr_per_pc: 340.00 },
                { size_mm: "110", length_socket: "3 FT S/S", product_code: "M41123309", std_pkg: 1, price_inr_per_pc: 496.00 },
                { size_mm: "110", length_socket: "6 FT D/S", product_code: "M41126609", std_pkg: 1, price_inr_per_pc: 5754.00 },
                { size_mm: "160", length_socket: "3 M S/S", product_code: "M41120312", std_pkg: 1, price_inr_per_pc: 3070.00 },
                { size_mm: "160", length_socket: "6 M S/S", product_code: "M41120612", std_pkg: 1, price_inr_per_pc: 5754.00 },
                { size_mm: "160", length_socket: "3 M D/S", product_code: "M42120312", std_pkg: 1, price_inr_per_pc: 6168.00 },
                { size_mm: "160", length_socket: "2 FT D/S", product_code: "M42120212", std_pkg: 1, price_inr_per_pc: 733.00 },
                { size_mm: "160", length_socket: "3 FT D/S", product_code: "M42121312", std_pkg: 1, price_inr_per_pc: 1088.00 },
                { size_mm: "160", length_socket: "4 FT D/S", product_code: "M41124412", std_pkg: 1, price_inr_per_pc: 1358.00 },
                { size_mm: "160", length_socket: "6 FT D/S", product_code: "M42110612", std_pkg: 1, price_inr_per_pc: 1970.00 },
                { size_mm: "160", length_socket: "2 FT S/S", product_code: "M41122212", std_pkg: 1, price_inr_per_pc: 664.00 },
                { size_mm: "160", length_socket: "3 FT S/S", product_code: "M41123312", std_pkg: 1, price_inr_per_pc: 1004.00 },
                { size_mm: "160", length_socket: "4 FT S/S", product_code: "M41124412", std_pkg: 1, price_inr_per_pc: 1249.00 }
            ]
        },
        {
            name: "PIPES TYPE - B (ADDITIONAL SIZES)",
            type: "B",
            fitting_type: "RING FIT",
            items: [
                { size_mm: "75", length_socket: "3M S/S", product_code: "M42120307", std_pkg: 1, price_inr_per_pc: 1950.00 },
                { size_mm: "75", length_socket: "3 M D/S", product_code: "M42120307", std_pkg: 1, price_inr_per_pc: 1040.00 },
                { size_mm: "75", length_socket: "6 M D/S", product_code: "M42120607", std_pkg: 1, price_inr_per_pc: 2070.00 },
                { size_mm: "75", length_socket: "2 FT D/S", product_code: "M42122207", std_pkg: 1, price_inr_per_pc: 263.00 },
                { size_mm: "75", length_socket: "3 FT D/S", product_code: "M42123307", std_pkg: 1, price_inr_per_pc: 374.00 },
                { size_mm: "75", length_socket: "6 FT D/S", product_code: "M42124607", std_pkg: 1, price_inr_per_pc: 495.00 },
                { size_mm: "90", length_socket: "3M S/S", product_code: "M44120308", std_pkg: 1, price_inr_per_pc: 1275.00 },
                { size_mm: "90", length_socket: "6 M S/S", product_code: "M44120608", std_pkg: 1, price_inr_per_pc: 2502.00 },
                { size_mm: "90", length_socket: "3 M D/S", product_code: "M42120308", std_pkg: 1, price_inr_per_pc: 1287.00 },
                { size_mm: "90", length_socket: "6 M D/S", product_code: "M42120608", std_pkg: 1, price_inr_per_pc: 2568.00 },
                { size_mm: "90", length_socket: "2 FT D/S", product_code: "M42122208", std_pkg: 1, price_inr_per_pc: 288.00 },
                { size_mm: "90", length_socket: "3 FT D/S", product_code: "M42123308", std_pkg: 1, price_inr_per_pc: 467.00 },
                { size_mm: "90", length_socket: "4 FT D/S", product_code: "M42124408", std_pkg: 1, price_inr_per_pc: 573.00 },
                { size_mm: "90", length_socket: "6 FT D/S", product_code: "M42126408", std_pkg: 1, price_inr_per_pc: 849.00 },
                { size_mm: "90", length_socket: "2 FT S/S", product_code: "M44122208", std_pkg: 1, price_inr_per_pc: 269.00 }
            ]
        },
        {
            name: "PIPES TYPE - B (LARGER SIZES)",
            type: "B",
            fitting_type: "RING FIT",
            items: [
                { size_mm: "200", length_socket: "3M S/S", product_code: "M41120314", std_pkg: 1, price_inr_per_pc: 6730.00 },
                { size_mm: "200", length_socket: "6 M S/S", product_code: "M41120614", std_pkg: 1, price_inr_per_pc: 9350.00 },
                { size_mm: "200", length_socket: "3 M D/S", product_code: "M42120314", std_pkg: 1, price_inr_per_pc: 6731.00 },
                { size_mm: "200", length_socket: "2 FT D/S", product_code: "M42120214", std_pkg: 1, price_inr_per_pc: 736.00 },
                { size_mm: "250", length_socket: "3M S/S", product_code: "M41120316", std_pkg: 1, price_inr_per_pc: 7470.00 },
                { size_mm: "250", length_socket: "6 M S/S", product_code: "M41120616", std_pkg: 1, price_inr_per_pc: 14644.00 },
                { size_mm: "315", length_socket: "3M S/S", product_code: "M41120318", std_pkg: 1, price_inr_per_pc: 11694.00 },
                { size_mm: "315", length_socket: "6 M S/S", product_code: "M41120618", std_pkg: 1, price_inr_per_pc: 22784.00 }
            ]
        }
    ]
};

// Helper functions
export const formatPrice = (price) => {
    return new Intl.NumberFormat('en-IN', {
        style: 'currency',
        currency: 'INR',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    }).format(price);
};

export const getAllDrainMasterProducts = () => {
    const allProducts = [];
    drainmasterCatalog.sections.forEach((section, sectionIndex) => {
        section.items.forEach((item, itemIndex) => {
            allProducts.push({
                id: `drainmaster-${sectionIndex}-${itemIndex}`,
                ...item,
                sectionName: section.name,
                type: section.type,
                fittingType: section.fitting_type,
                hsnCode: drainmasterCatalog.hsn_code
            });
        });
    });
    return allProducts;
};

export const getDrainMasterSizes = () => {
    const allProducts = getAllDrainMasterProducts();
    return [...new Set(allProducts.map(p => p.size_mm))].sort((a, b) => parseInt(a) - parseInt(b));
};

export const getDrainMasterTypes = () => {
    return [...new Set(drainmasterCatalog.sections.map(s => s.type))];
};

export const getDrainMasterFittingTypes = () => {
    return [...new Set(drainmasterCatalog.sections.map(s => s.fitting_type))];
};
